<template>
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <!-- Content Row -->
    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <!-- <div class="col-xl-3 col-md-6 mb-4">
        <vacantes />
      </div> -->

      <!-- Earnings (Monthly) Card Example -->
      <!-- <div class="col-xl-3 col-md-6 mb-4">
        <postulaciones />
      </div> -->

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <visitashoy />
      </div>

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <visitas />
      </div>
    </div>

    <!-- Content Row -->

    <div class="row">
      <!-- Content Column -->
      <div class="col-xl-6 col-lg-5">
        <!-- Project Card Example -->
        <postulacionesgrafica />
      </div>

      <!-- Area Chart -->
      <div class="col-xl-6 col-lg-7"></div>
    </div>
  </div>
</template>

<script>
import postulaciones from "./postulaciones.vue";
import postulacionesgrafica from "./postulaciones_grafica.vue";
import vacantes from "./vacantes.vue";
import visitas from "./visitas.vue";
import visitashoy from "./visitas_hoy.vue";
export default {
  data() {
    return {};
  },
  components: {
    vacantes,
    postulaciones,
    postulacionesgrafica,
    visitas,
    visitashoy
  },
  methods: {
    Ruta(name) {
      this.$router.push({ name: name });
    },
    Nada() {}
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue